<template>
  <div class="category-percentages">
    <h3 class="title">Wat sturen we<br>het meest terug?</h3>
    <ul class="list">
      <CategoryItem v-bind="fashion" />
    </ul>
    <FashionPart />
    <ul class="list">
      <CategoryItem
        v-for="(cat, index) in categories"
        :key="index"
        v-bind="cat"
      />
    </ul>
  </div>
</template>

<script>
import CategoryItem from './CategoryItem'
import FashionPart from './FashionPart'
import { Fashion, Electronics, Sports, Living, Books } from './icons'

export default {
  name: 'CategoryPercentages',
  data () {
    return {
      fashion: {
        name: 'Mode',
        value: 40,
        strips: 8,
        icon: Fashion
      },
      categories: [{
        name: 'Elektronica',
        value: 15,
        strips: 3,
        icon: Electronics
      }, {
        name: 'Sportartikelen',
        value: 10,
        strips: 2,
        icon: Sports
      }, {
        name: 'Woonartikelen',
        value: 7.5,
        strips: 1.5,
        icon: Living
      }, {
        name: 'Boeken',
        value: 5,
        strips: 1,
        icon: Books
      }]
    }
  },
  components: {
    CategoryItem,
    FashionPart
  }
}
</script>

<style lang="scss" scoped>
.category-percentages {
  margin: 0 auto 3em;
  background-color: $c-brown;
  border-radius: 10px;
  padding: 48px 0 18px;
  width: 407px;
  color: $c-text;
  overflow: hidden;
  position: relative;

  @media (max-width: 407px) {
    width: 100%;
    border-radius: 0;
  }
}

.title {
  font-size: $fs-h3;
  margin: 0 auto 1em;
  color: white;
  text-align: center;
}

.list {
  padding: 0;
  margin: 0;
}
</style>
